import { atom } from 'recoil';

let userInfo = atom<any>({
  key: 'userInfo',
  default: {
    ctn: '',
    mgntCd: '',
    srcCd: '',
    osType: '',
    mediaCd: '',
    trackCd: '',
    queueSeq: '',
    appUserId: '',
    appUserPartIdx: '',
    passMoney: '',
    passAppId: '',
    version: '',
  },
});

export { userInfo };
